import { IconType } from 'react-icons';
import { Link as RouterLink, useLocation } from 'react-router';

import { Box, Flex, FlexProps, Icon } from '@chakra-ui/react';

interface NavItemProps extends FlexProps {
  icon: IconType;
  children: React.ReactNode;
  to: string;
  onClick?: () => void;
}

const SidebarItem = ({
  icon,
  children,
  to,
  onClick,
  ...rest
}: NavItemProps) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(to) && to !== '#';

  const activeColor = 'teal.600';
  const activeBg = 'teal.600';
  const hoverBg = 'gray.100';
  const activeTextColor = 'white';
  const textColor = 'gray.900';

  return (
    <RouterLink to={to} style={{ textDecoration: 'none' }} onClick={onClick}>
      <Box _focus={{ boxShadow: 'none' }}>
        <Flex
          align="center"
          px="4"
          py={{ base: 1.5, md: 2.5 }}
          mx="4"
          borderRadius="md"
          role="group"
          cursor="pointer"
          transition="all 0.2s ease"
          _hover={{
            bg: isActive ? activeBg : hoverBg,
            color: isActive ? activeTextColor : textColor,
          }}
          bg={isActive ? activeBg : 'transparent'}
          color={isActive ? activeTextColor : textColor}
          position="relative"
          {...rest}
        >
          {isActive && (
            <Box
              position="absolute"
              left="0"
              top="0"
              bottom="0"
              width="2px"
              borderRadius="full"
              bg={activeColor}
            />
          )}
          {icon && (
            <Icon
              mr="4"
              fontSize="18"
              as={icon}
              color={isActive ? activeTextColor : 'inherit'}
              transition="all 0.2s"
              _groupHover={{
                transform: 'scale(1.1)',
              }}
            />
          )}
          {children}
        </Flex>
      </Box>
    </RouterLink>
  );
};

export default SidebarItem;
